import { useMemo, useEffect } from 'react';
import Layout from 'components/layout';
import { useRecoilValue } from 'recoil';
import { getUser } from 'hooks/useUser';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';
import styles from '../style.module.scss';
import AdminView from '../adminView';
import ManagerView from '../managerView';
import useBreadcrumb from 'hooks/useBreadcrumb';

const DashboardPage = () => {
  const user = useRecoilValue(getUser);
  const { t } = useTranslation();
  const { setBreadcrumb } = useBreadcrumb();

  const breadcrumb = useMemo(() => {
    if (user.isAdmin) {
      return [
        {
          title: 'Super admin',
          link: '#',
        },
        {
          title: 'Dashboard',
          link: '#',
        },
      ];
    }

    if (user.isOwner) {
      return [
        {
          title: 'Owner',
          link: '#',
        },
        {
          title: 'Dashboard',
          link: '#',
        },
      ];
    }

    return [
      {
        title: user?.currentShop?.title,
        link: '#',
      },
      {
        title: 'Dashboard',
        link: '#',
      },
    ];
  }, [user]);

  useEffect(() => {
    setBreadcrumb(breadcrumb);
  }, [user?.currentShop?.title]);

  return (
    <Layout breadcrumb={breadcrumb}>
      <div className={styles.container}>
        <Card className={styles.card} title={t('Dashboard')}>
          {user.isManager && <ManagerView />}
          {(user.isAdmin || user.isOwner) && <AdminView />}
        </Card>
      </div>
    </Layout>
  );
};

export default DashboardPage;
